import styled, { css } from "styled-components";

interface Props {
  hasNotification?: any;
  hasSelected?: boolean;
  menuSidebar: boolean;
  isAdmin?: boolean;
  inProfile?: boolean;
}

export const Container = styled.div<Props>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${({ menuSidebar }) => (menuSidebar ? "80px" : "304px")};
  height: 100vh;
  box-shadow: 0px 4px 22.5px 0px rgba(0, 0, 0, 0.15);
  background-color: ${(props: any) => props.theme.colors.interfacePure0}; /* light: #FFF — era '#FFFFFF' (chumbado + CSS inválido c/ aspas) */
  transition: width 0.35s ease;

  @media (max-width: 500px) {
      min-width: ${({ menuSidebar }) => (menuSidebar ? "80px" : "230px")};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  /* padding: 0 16px; */
  /* margin-top: 32px; */
  margin: 32px 10px 32px 10px;
`;

export const Header = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: ${({ menuSidebar }) => !menuSidebar ? "space-between" : "center"};
  width: 100%;
  /* margin-bottom: 32px; */
  /* border: 1px solid red; */

  .sideButtonBackToPage {
    /* display: grid; */
    display: ${({ menuSidebar }) => (!menuSidebar ? "grid" : "none")};
    place-items: center;
    border: none;
    background-color: transparent;
    border-radius: 50%;
  }

  .sideLogo {
    display: ${({ menuSidebar }) => (!menuSidebar ? "none" : "grid")};;
  }
`;

export const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  height: 100%;
  gap: 1rem;
  margin-bottom: 25px;

  overflow-y: auto;
  ::-webkit-scrollbar {
    /* display: none; */
  }
`;

export const Li = styled.li<Props>`
  position: relative;

  &:first-child {
    .sideLiRight {
      &::after {
        background: transparent;
      }
      .sideButtonLi {
        display: none;
      }
    }
  }

  &::after {
    content: '•';
    display: ${({ hasNotification, menuSidebar }) => (hasNotification && menuSidebar ? "flex" : "none")};
    align-items: center;
    justify-content: center;
    line-height: 18px;
    position: absolute;
    right: 5px;
    top: -5px;
    font-size: 40px;
    color: ${(props: any) => props.theme.colors.redDev};
  }

  a {
    display: flex;
    align-items: center;
    justify-content: ${({ menuSidebar }) =>
      !menuSidebar ? "space-between" : "center"};
    padding: 10px 9px;
    border-radius: 8px;
    background-color: transparent;
    
    cursor: pointer;
    .sideLiLeft {
      display: flex;
      align-items: center;
      gap: 0.75rem;

      .sideTitleLi {
        display: ${({ menuSidebar }) => (!menuSidebar ? "block" : "none")};
        font-size: 1rem;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.interfaceGray300};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      svg {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        path { fill: ${({ theme }) => theme.colors.interfaceGray300}; }
      }

      svg.bell {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        path { fill: none; stroke: ${({ theme }) => theme.colors.interfaceGray300}; }
      }

      .sideButtonLi {
        display: grid;
        place-items: center;
        border: none;
        background-color: transparent;
      }

      &::after {
        width: 27px;
        min-width: 16px;
        line-height: 18px;
        padding: 4px;
        position: absolute;
        right: 22px;
        border-radius: 4px;
        background-color: ${(props: any) => props.hasNotification === undefined ? 'transparent' : 'var(--count-badge-bg)'};
        border: none;
        text-align: center;
        font-size: 11px;
        font-weight: 600;
        color: var(--count-badge-ink);
        content: "${({ hasNotification }) => hasNotification ?? ''}";
        display: ${({ hasNotification, menuSidebar }) =>
          menuSidebar || (!hasNotification || hasNotification < 0) ? 'none' : 'inline'};
      }
    }

    ${(props) =>
      props.hasSelected &&
      css`
        color: ${({ theme }) => theme.colors.interfacePure0};
        font-weight: 600;

        svg {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
          path {
            fill: ${({ theme }) => theme.colors.primaryRed400};
          }
        }

        .sideLiLeft {
          .sideTitleLi {
            color: ${({ theme }) => theme.colors.interfacePure600};
          }
          svg {
            width: 24px;
            height: 24px;
            flex-shrink: 0;
            path { fill: ${({ theme }) => theme.colors.primaryRed400}; }
          }
          svg.bell {
            width: 24px;
            height: 24px;
            flex-shrink: 0;
            path { stroke: ${({ theme }) => theme.colors.primaryRed400};
          }
        }

        .sideLiRight {
          .sideButtonLi {
            svg {
              path {
                fill: ${({ theme }) => theme.colors.interfacePure0};
              }
            }
          }
          &::after {
            background-color: ${(props: any) => props.hasNotification === undefined ? 'transparent' : props.theme.colors.primaryRed400};
          }
        }
      `}
  }
`;

export const SectionFooter = styled.div<Props>`
  display: flex;
  flex-direction: column;
  background-color: ${(props) =>
    props.isAdmin
    ? props.theme.colors.primaryRed400          
    : props.theme.colors.interfaceGray600};
  border-radius: 8px 8px 0 0;
  padding: 12px 20px;
  position: relative;
`;

export const ProfileFooter = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
  position: relative;

  .avatarUser {
    position: absolute;
    top: -28px;
    left: 0px;
    padding: 8px;
    border-radius: 8px;
    /* mantém a cor do light nos dois temas: no dark o token primaryRed600/interfaceGray500
       vira um tint claro e deixava o avatar "lavado" sobre o rodapé vermelho */
    background-color: ${(props) =>
      props.isAdmin ? '#7e1925' : '#6F777E'};
  }

  .sideButtonFooter {
    display: grid;
    place-items: center;
    border: none;
    background-color: transparent;
    opacity: ${({ menuSidebar }) => (!menuSidebar ? "1" : "0")};
    cursor: pointer;
  }
`;

export const DescriptionProfileFooter = styled.div<Props>`
  display: flex;
  flex-direction: column;

  h2 {
    display: ${({ menuSidebar }) => (!menuSidebar ? "block" : "none")};
    font-size: 1.25rem;
    white-space: nowrap;
    font-weight: 500;
    color: ${(props: any) => props.theme.colors.pureWhite };
    margin-bottom: 2px;
    text-align: ${({ menuSidebar }) => (!menuSidebar ? "initial" : "center")};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
  }

  span {
    margin-top: 2px;
    font-size: 0.875rem;
    font-weight: 600;
    color: ${(props: any) => props.theme.colors.pureWhite};
    text-align: ${({ menuSidebar }) => (!menuSidebar ? "initial" : "center")};
  }

  .sideButtonFooter {
    display: grid;
    place-items: center;
    border: none;
    background-color: transparent;    
  }
`;

export const SectionLogout = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: ${({ menuSidebar }) => !menuSidebar ? "flex-end" : "center"};
  margin-bottom: ${({ menuSidebar }) => (!menuSidebar ? "8px" : "22px")};
  padding: 0 16px;

  .sideButtonLogout {
    display: flex;
    align-content: center;
    justify-content: center;
    border: none;
    background-color: transparent;

    svg {
      width: 22px;
    }
    span {
      padding: 4px;
      text-align: center;
      font-size: 0.875rem;
      color: ${(props: any) => props.theme.colors.pureWhite};
      display: ${({ menuSidebar }) => (!menuSidebar ? "block" : "none")};
    }
  }
`;